import Icon from "@ant-design/icons";

const RestaurantSVG = () => {
  return (
    <svg
      height="25"
      width="25"
      version="1.1"
      fill="#31493C"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 254.019 254.019"
      xmlSpace="preserve">
      <g>
        <g>
          <g>
            <path
              d="M126.514,48.282c-43.428,0-78.738,35.319-78.738,78.738c0,43.389,35.309,78.718,78.738,78.718
                c43.389,0,78.738-35.329,78.738-78.708C205.252,83.601,169.932,48.282,126.514,48.282z M126.514,198.898
                c-39.647,0-71.879-32.232-71.879-71.869s32.222-71.928,71.879-71.928s71.879,32.29,71.879,71.928
                S166.171,198.898,126.514,198.898z M193.352,127.029c0,36.882-29.926,66.808-66.828,66.808
                c-36.912,0-66.838-29.936-66.838-66.808c0-36.921,29.936-66.847,66.838-66.847C163.426,60.172,193.352,90.108,193.352,127.029z
                M41.308,56.733l0.02,38.836h-0.059c-0.391,12.389-13.971,17.117-13.971,17.117v24.924h0.02l-0.02,57.312
                c0,0-5.491,7.093-12.604,0v-82.226h0.166c-8.285-3.527-14.411-4.748-14.802-17.117H0V56.733l6.224-0.029L9.252,94.28H16.6
                l0.928-38.348h5.989l0.723,38.348h8.617l1.983-37.547L41.308,56.733L41.308,56.733z M252.1,122.857h-15.232v77.038h-17.596
                V54.144h17.596C236.878,54.134,260.844,84.548,252.1,122.857z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const RestaurantIcon = (props) => <Icon component={RestaurantSVG} {...props} />;

export default RestaurantIcon;
